import { LitElement, html, css } from 'lit';
import '../common.css';
import logo from '../../images/logo.webp';
import favicon from '../../images/favicon.png';
import arrowRight from '../../images/arrow-right.svg';

class Header extends LitElement {
  static get properties() {
    return {
      message: {type: String},
    };
  }

  constructor() {
    super();
  }

  firstUpdated() {
    const toggleBtn = this.shadowRoot.querySelector('.toggle-btn');
    const header = this.shadowRoot.querySelector('.header');

    toggleBtn.addEventListener('click', () => {
      header.classList.toggle('nav-active');
    });

    const query = new URLSearchParams(window.location.search);

    if (query.get('success')) {
      this.message = 'Order placed! You will receive an email confirmation.';
    }

    if (query.get('canceled')) {
      this.message =
        'Order canceled -- continue to shop around and checkout when you\'re ready.';
    }
    this.requestUpdate();
  }

  handleGetStartedFreeClick() {
    window.location.href = '/signup';
  }

  handleLogInClick() {
    window.location.href = '/signin';
  }

  redirectToUrl(url) {
    window.location.href = url;
  }

  static get styles() {
    return css`
      * {
        box-sizing: border-box;
      }

      .container {
        max-width: 1200px;
        margin: 0 auto;
        font-family: "Outfit", sans-serif;
      }

      @media (max-width: 1024px) {
        .container {
          padding: 0 15px;
        }
      }

      .btn {
        font-weight: 500;
        padding: 15px 20px;
        cursor: pointer;
        font-size: 16px;
        border: none;
        outline: none;
        border-radius: 4px;
        font-family: "Outfit", sans-serif;
      }

      .btn #buttonDiv {
        opacity: 0.0000002;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .btn span {
        display: inline-flex;
        align-items: center;
      }

      .btn i {
        line-height: 0;
      }

      .btn-primary {
        background-color: #3346e7;
        color: #fff;
        transition: all 0.5s ease;
      }
      .btn-primary:hover {
        opacity: 0.8;
      }
      .btn-primary i {
        margin: 0 0 0 15px;
        filter: invert(100%);
      }
      .btn-primary i::before {
        color: #fff;
      }

      .btn-text {
        background-color: #fff;
        color: #3346e7;
        padding-top: 13px;
        padding-bottom: 13px;
        position: relative;
        overflow: hidden;
      }
      .btn-text i {
        margin: 0 0 0 15px;
      }
      .btn-text i::before {
        color: #222;
      }
      .btn-text.text-black {
        color: #222;
        transition: all 0.5s ease;
        border: 1px solid #fff;
      }
      .btn-text.text-black:hover {
        background-color: transparent;
        border: 1px solid #fff;
        color: #fff;
      }
      .btn-text.text-black:hover i::before {
        color: #fff;
      }

      .header {
        padding: 12px 0;
        background-color: #fff;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
        position: relative;
      }
      @media (max-width: 578px) {
        .header {
          padding: 12px 0;
        }
      }
      .header .menu-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .header .toggle-btn {
        display: none;
        position: relative;
        width: 25px;
        height: 20px;
        border-top: 2px solid #000;
        transition: all 0.4s ease;
        left: -5px;
      }
      @media (max-width: 767px) {
        .header .toggle-btn {
          display: block;
        }
      }
      .nav-active.header .toggle-btn {
        border: none;
      }
      .header .toggle-btn::before,
      .header .toggle-btn::after {
        content: "";
        right: 0;
        top: 5px;
        width: 25px;
        height: 2px;
        background-color: #000;
        margin: 0;
        position: absolute;
        transition: all 0.4s ease;
      }
      .nav-active.header .toggle-btn::before,
      .nav-active.header .toggle-btn::after {
        transform: rotate(45deg);
        top: 10px;
      }
      .header .toggle-btn::before {
        top: 13px;
      }
      .nav-active.header .toggle-btn::before {
        transform: rotate(-45deg);
        top: 10px;
      }
      .header .navbar {
        justify-content: space-between;
        display: flex;
        align-items: center;
      }
      @media (max-width: 767px) {
        .header .navbar {
          display: block;
        }
      }
      .header .menu-bar .logo {
        overflow: hidden;
      }
      .header .menu-bar .logo a {
        display: flex;
      }
      .header .menu-bar .logo .logo-img {
        width: 194px;
        height: 56px;
        object-fit: cover;
        display: block;
        margin-left: -10px;
      }
      .header .menu-bar .logo .favicon-img {
        width: 56px;
        height: 56px;
        object-fit: cover;
        display: block;
      }
      @media (max-width: 578px) {
        .header .menu-bar .logo .logo-img {
          width: 110px;
          height: 32px;
          margin-left: 0px;
        }
        .header .menu-bar .logo .favicon-img {
          width: 32px;
          height: 32px;
        }
      }
      .header .menu-wrap {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-grow: 1;
        flex-basis: 0;
        min-width: 0;
      }
      @media (max-width: 767px) {
        .header .menu-wrap {
          position: absolute;
          left: 0;
          right: 0;
          top: 100%;
          background-color: #fff;
          padding: 26px 0 0 0;
          display: block;
          opacity: 0;
          visibility: hidden;
          transition: all 0.4s ease;
          z-index: 3;
        }
        .nav-active.header .menu-wrap {
          opacity: 1;
          visibility: visible;
        }
      }
      .header .menu {
        display: flex;
        padding: 0;
        margin: 0;
        flex-grow: 1;
        flex-basis: 0;
        min-width: 0;
        justify-content: center;
      }
      @media (max-width: 767px) {
        .header .menu {
          display: block;
        }
      }
      .header .menu li {
        list-style: none;
        margin: 0 8px;
      }
      @media (max-width: 767px) {
        .header .menu li {
          margin: 0 0 27px 0;
          text-align: center;
        }
      }
      .header .menu a {
        color: #454545;
        text-decoration: none;
        transition: all 0.5s ease;
        line-height: 1.5;
        font-size: 16px;
      }
      .header .menu a:hover {
        color: #05b0fb;
      }
      @media (max-width: 578px) {
        .header .menu a {
          font-size: 14px;
        }
      }
      .header .menu .active {
        color: #05b0fb;
      }
      .header .btn-holder {
        display: flex;
        align-items: center;
      }
      @media (max-width: 767px) {
        .header .btn-holder {
          width: 100%;
          text-align: center;
          display: block;
        }
      }
      @media (max-width: 767px) {
        .header .btn-holder .btn-text {
          border: 1px solid #454545;
          color: #454545;
        }
      }
      @media (max-width: 767px) {
        .header .btn-holder button {
          margin: 0 0 23px;
        }
      }
      @media (max-width: 767px) {
        .header .btn-holder .visible-desktop {
          display: none;
        }
      }
      .header .btn-holder .visible-mobile {
        display: none;
      }
      @media (max-width: 767px) {
        .header .btn-holder .visible-mobile {
          display: inline-flex;
        }
      }
    `;
  }

  render() {
    return html`
      <header class="header">
        <div class="container">
          <div class="menu-bar">
            <strong class="logo">
              <a href="/landing">
                <img class="favicon-img" src="${favicon}" alt="Facicon" />
                <img class="logo-img" src="${logo}" alt="Logo" />
              </a>
            </strong>
            <div class="toggle-btn">
              <span class="bar"></span>
            </div>
            <div class="menu-wrap">
              <ul class="menu">
                <li><a href="/landing">Home</a></li>
                <li><a href="/feature">Features</a></li>
                <li><a href="/pricing">Pricing</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
              <div class="btn-holder">
                <button class="btn btn-text" id="buttonDiv" @click="${this.handleLogInClick}">
                  <span> Sign in </span>
                </button>
                <button class="btn btn-primary visible-desktop" @click="${this.handleGetStartedFreeClick}">
                  <span class="visible-desktop">
                    Get Started Free
                    <i class="icon">
                      <img src="${arrowRight}" />
                    </i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>
    `;
  }
}

customElements.define('component-header', Header);
